/** API client for /api/v1/mcp/* endpoints (MCP API key management). */

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8001';

export interface McpKeyCreated {
  id: number;
  key: string;       // raw key — returned once only
  key_prefix: string;
  label: string | null;
  created_at: string;
}

export interface McpKeyItem {
  id: number;
  key_prefix: string;
  label: string | null;
  last_used_at: string | null;
  created_at: string;
}

class McpApiService {
  private getToken(): string | null {
    return localStorage.getItem('token');
  }

  private async request<T>(method: string, path: string, body?: unknown): Promise<T> {
    const token = this.getToken();
    const res = await fetch(`${API_URL}/api/v1${path}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ detail: res.statusText }));
      throw new Error(err.detail || `HTTP ${res.status}`);
    }
    if (res.status === 204) return undefined as unknown as T;
    return res.json();
  }

  async generateKey(label?: string): Promise<McpKeyCreated> {
    return this.request<McpKeyCreated>('POST', '/mcp/keys', { label: label || null });
  }

  async listKeys(): Promise<McpKeyItem[]> {
    return this.request<McpKeyItem[]>('GET', '/mcp/keys');
  }

  async revokeKey(keyId: number): Promise<void> {
    return this.request<void>('DELETE', `/mcp/keys/${keyId}`);
  }
}

export const mcpApi = new McpApiService();
